import { render } from "./quotemensaje.vue?vue&type=template&id=793bea98&scoped=true"
import script from "./quotemensaje.vue?vue&type=script&lang=js"
export * from "./quotemensaje.vue?vue&type=script&lang=js"

import "./quotemensaje.vue?vue&type=style&index=0&id=793bea98&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-793bea98"]])

export default __exports__